import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  youtubePlayer: {
    position: "relative",
    margin: "auto",
    cursor: "pointer",
  },
  play: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: "-57px",
    marginLeft: "-65px",
    zIndex: 1,
  },
}));

export default useStyles;
